import { assign } from "../../helper.js";
import { isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/term.entity.js
var createTerm = () => ({
	id: "",
	name: "",
	physicalName: "",
	domainId: "",
	description: "",
	synonyms: "",
	order: ""
});
function createAndMergeTermEntities(values) {
	const entities = {};
	for (const value of values) {
		const target = createTerm();
		const assignString = assign(isString, target, value);
		assignString("id");
		assignString("name");
		assignString("physicalName");
		assignString("domainId");
		assignString("description");
		assignString("synonyms");
		assignString("order");
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeTermEntities, createTerm };
